<template>
  <!-- 村居通·二级页面 选择功能页 默认推广与使用 -->
  <div>
    <div id="cjt_select"
         ref="cjt_select">
      <div class="echarts_border">
        <div class="btnBox">
          <div v-for="(item, index) in menuList"
               :key="index"
               :class="[isActive == index ? 'activeBtn' : 'btn']"
               @click="selectCjtModule(index)">
            <p class="btnTitle">{{ item.title }}</p>
          </div>
        </div>

        <!-- 推广与使用 -->
        <PromotionUse v-if="this.isActive == 0" />
        <!-- 环境治理
        <Governance v-if="this.isActive == 1" /> -->
        <!-- 民意收集 -->
        <Collection v-if="this.isActive == 1" />
      </div>
    </div>
  </div>
</template>

<script>
// 推广与使用
import PromotionUse from "./promotion_use.vue";
// 环境治理
// import Governance from "./governance.vue";
// 民意收集
import Collection from "./collection.vue";
export default {
  components: {
    PromotionUse,
    // Governance,
    Collection,
  },
  props: {},
  data() {
    return {
      menuList: [
        { title: "宣传推广" },
        // { title: "环境治理" },
        { title: "民意收集" },
      ],
      isActive: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 选择村居通模块
    selectCjtModule(index) {
      this.isActive = index;
      if (index === 0) {
        plOtherDataInterface.getVillagerNum();
      }
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
#cjt_select {
  background: #15606e;
  border-top: 1px solid rgb(121, 226, 154);
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.btnBox {
  margin: 34px 2rem;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content:space-around;
}
.btn {
  width: 28%;
  height: 39px;
  // opacity: 0.3;
  background: rgba(138, 206, 254, 0.3);
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.activeBtn {
  width: 28%;
  height: 39px;
  // opacity: 0.47;
  background: rgba(0, 48, 82, 0.47);
  border: 1px solid #3ef89c;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.btnTitle {
  font-size: 22px;
  font-family: PingFang-SC-Medium;
  color: #ebfaff;
  line-height: 39px;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt/select_cjt.vue